const Constants = {

    REPLY_TITLE_REPLY: "Write your reply",
    REPLY_TITLE_NEW_DISCUSSION: "Message",

    FILTER_TODAY: 0,
    FILTER_YESTERDAY: 1,
    FILTER_LAST_WEEK: 2,
    FILTER_LAST_MONTH: 3,
    FILTER_BEGINNING: 4,

}

export {Constants};